import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=5472e078&scoped=true&"
import script from "./distributor.vue?vue&type=script&lang=js&"
export * from "./distributor.vue?vue&type=script&lang=js&"
import style0 from "./distributor.vue?vue&type=style&index=0&id=5472e078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472e078",
  null
  
)

export default component.exports